// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b7674f78","455":"8bf285a2","977":"92f6eb4f"}[chunkId] + ".chunk.js";
};